import React, { createContext, useEffect, useLayoutEffect, useMemo, useState, useContext } from "react";
import theme from "tailwindcss/defaultTheme";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import DARK_MODE from "../constants/darkMode.constant";
import themeConfig from "../config/theme.config";
import useDeviceScreen from "../hooks/useDeviceScreen";

// Create a context
const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  /**
   * Language
   */
  // const { i18n } = useTranslation();
  // const [language, setLanguage] = useState(localStorage.getItem("fyr_language") || themeConfig.language);

  // useLayoutEffect(() => {
  //   localStorage.setItem("fyr_language", language);

  //   i18n
  //     .changeLanguage(language)
  //     .then(() => {
  //       document.documentElement.setAttribute("dir", i18n.dir());
  //       document.documentElement.setAttribute("lang", i18n.language);
  //     })
  //     .catch(() => {});

  //   // Changing the global locale doesn't affect existing instances.
  //   dayjs.locale(language);
  // }, [language]);

  /**
   * Dark Mode
   */
  const [darkModeStatus, setDarkModeStatus] = useState(localStorage.getItem("theme") || themeConfig.theme);
  const [isDarkTheme, setIsDarkTheme] = useState(darkModeStatus === DARK_MODE.DARK);

  useLayoutEffect(() => {
    localStorage.setItem("theme", darkModeStatus);

    if (
      localStorage.getItem("theme") === DARK_MODE.DARK ||
      (localStorage.getItem("theme") === DARK_MODE.SYSTEM &&
        window.matchMedia(`(prefers-color-scheme: ${DARK_MODE.DARK})`).matches)
    ) {
      document.documentElement.classList.add(DARK_MODE.DARK);
      setIsDarkTheme(true);
    } else {
      document.documentElement.classList.remove(DARK_MODE.DARK);
      setIsDarkTheme(false);
    }
  }, [darkModeStatus]);

  /**
   * Aside Status
   */
  const { width } = useDeviceScreen();
  const [asideStatus, setAsideStatus] = useState(
    localStorage.getItem("fyr_asideStatus") ? localStorage.getItem("fyr_asideStatus") === "true" : true
  );

  useLayoutEffect(() => {
    if (Number(theme.screens.md.replace("px", "")) <= Number(width)) {
      localStorage.setItem("fyr_asideStatus", asideStatus.toString());
    }
  }, [asideStatus]);

  useEffect(() => {
    if (Number(theme.screens.md.replace("px", "")) > Number(width)) {
      setAsideStatus(false);
    }
    return () => {
      setAsideStatus(
        localStorage.getItem("fyr_asideStatus") ? localStorage.getItem("fyr_asideStatus") === "true" : true
      );
    };
  }, [width]);

  /**
   * Font Size
   */
  const [fontSize, setFontSize] = useState(
    Number(localStorage.getItem("fyr_fontSize")) ? Number(localStorage.getItem("fyr_fontSize")) : themeConfig.fontSize
  );

  useLayoutEffect(() => {
    localStorage.setItem("fyr_fontSize", fontSize.toString());
  }, [fontSize]);

  const values = useMemo(
    () => ({
      isDarkTheme,
      darkModeStatus,
      setDarkModeStatus,
      asideStatus,
      setAsideStatus,
      fontSize,
      setFontSize,
      // language,
      // setLanguage,
    }),
    [isDarkTheme, darkModeStatus, asideStatus, fontSize]
  );

  return <ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>;
};

export default ThemeContext;
